import DoAPICall from './DoAPICall'

//Send SMS
export async function sendTheSMS(userToken, smsPayload){
    const apiPayload = {
        httpMethod:'post',
        userToken,
        uri:'messages',
        payLoad:{
            mobileNumber:smsPayload.mobileNumber,
            client_id:smsPayload.client_id,
            message:smsPayload.message
        },
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}

export async function sendBulk(userToken, smsPayload){
    const apiPayload = {
        httpMethod:'post',
        userToken,
        uri:'messages/bulk',
        payLoad:{
            client_id:smsPayload.client_id,
            mobileNumbers:smsPayload.mobileNumbers,
            message:smsPayload.message,
        },
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}

export async function sendBulkCustom(userToken, smsPayload){

    const apiPayload = {
        httpMethod:'post',
        userToken,
        uri:'messages/bulkcustom',
        payLoad:{
            client_id:smsPayload.client_id,
            mobileNumbers:smsPayload.mobileNumbers,
        },
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}

//Get All SMSes
export async function getSMSes(userToken,params){
    const apiPayload = {
        httpMethod:'get',
        userToken,
        uri:'smses?dateFrom='+params.from+'&dateTo='+params.to+'&client_id='+params.client_id,
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}

//Get One SMS
export async function getSMS(userToken, id){
    const apiPayload = {
        httpMethod:'get',
        userToken,
        uri:'messages/'+id,
        payLoad:{},
        requestOptions:{}
    }
    return await DoAPICall(apiPayload)
}

//Get All Analytics
export async function getMainSMSDashboard(userToken,theMonth){
    const apiPayload = {
       httpMethod:'get',
       userToken,
       uri:'mainsmsdashboard?theMonth='+theMonth,
       payLoad:{},
       requestOptions:{}
    }
    return await DoAPICall(apiPayload)
 }

export async function getClientSMSDashboard(userToken,params){
    const apiPayload = {
       httpMethod:'get',
       userToken,
       uri:'clientsmsdashboard?dateFrom='+params.from+'&dateTo='+params.to+'&client_id='+params.client_id,
       payLoad:{},
       requestOptions:{}
    }
    return await DoAPICall(apiPayload)
 }